import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Index from './layouts/Index';
import Dashboard from './layouts/Dashboard';
import { ToastContainer } from 'react-toastify';
import { WalletProvider } from './chain/WalletContext';
import BpBackground from './fx/BpBackground';
import initInteractiveFX from './fx/interactive';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
    useEffect(() => { initInteractiveFX(); }, []);
    return (
        <WalletProvider>
            <BpBackground />
            <BrowserRouter>
                <Routes>
                    <Route path='/dashboard/*' element={<Dashboard />} />
                    <Route path='/*' element={<Index />} />
                </Routes>
                <ToastContainer theme="dark" position="bottom-right" />
            </BrowserRouter>
        </WalletProvider>
    );
}
